<template>
    <div class="container mx-auto p-4 max-w-7xl">
        <h1 class="font-bold mb-4 text-center text-4xl text-primary py-7 mt-10">
            {{ t('projects.title') }}
        </h1>

        <div v-if="!loading && !error" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <div v-for="project in visibleProjects" :key="project.id"
                class="rounded-3xl shadow-xl my-4 bg-white dark:bg-[#5b5b5b] overflow-hidden">

                <router-link :to="'/projects/' + project.id" class="block w-full">
                    <img :src="project.main_image" alt="Project image"
                        class="w-full h-56 object-cover hover:opacity-90 transition-opacity">
                </router-link>

                <div class="p-5 flex items-center justify-between">
                    <h2 class="text-xl font-bold dark:text-white opacity-75">
                        {{ project.name }}
                    </h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t, tm, locale } = useI18n();
const loading = ref(false);
const error = ref(null);
const route = useRoute();
const isImageLoading = ref({});
const visibleProjectsCount = ref(9);
const filter = ref('all');

// دالة لجلب مسار الصورة
const getImageUrl = (id) => {
  return new URL(`../assets/Backend/projects/project${id}/main.webp`, import.meta.url).href;
};

// جلب البيانات من ملفات الترجمة
const projects = computed(() => {
  const data = tm('projectsData');
  if (Array.isArray(data)) {
    return data.map(project => ({
      ...project,
      main_image: getImageUrl(project.id)
    }));
  }
  return [];
});

// الفلاتر
const visibleProjects = computed(() => {
    if (filter.value === 'completed') {
        return projects.value.filter(project => project.ending_date);
    } else if (filter.value === 'ongoing') {
        return projects.value.filter(project => project.starting_date && !project.ending_date);
    }
    return projects.value;
});

function preloadImage(url, projectId) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            handleImageLoad(projectId);
            resolve();
        };
        img.onerror = () => {
            handleImageError(projectId);
            reject();
        };
    });
}

function handleImageLoad(projectId) {
    isImageLoading.value[projectId] = false;
}

function handleImageError(projectId) {
    isImageLoading.value[projectId] = false;
}

function isActiveProject(projectId) {
    return projectId === Number(route.params.id);
}

function showMoreProjects() {
    visibleProjectsCount.value += 9;
}

function filterCompletedProjects() {
    filter.value = 'completed';
}

function filterOngoingProjects() {
    filter.value = 'ongoing';
}

function resetFilter() {
    filter.value = 'all';
}

// محاكاة التحميل (اختياري)
onMounted(() => {
    loading.value = true;
    setTimeout(() => {
        loading.value = false;
    }, 500);
});
</script>

<style scoped>
.container {
    margin-top: 50px;
}
.grid {
    gap: 20px;
}

button:focus {
    @apply outline-none ring-2 ring-primary ring-opacity-50;
}
</style>